export const REQUEST_LINEAR_GRAPH_DATA = '[dashboard] Request linear graph data' as const;
export const SET_LINEAR_GRAPH_MODE = '[dashboard] Set linear graph mode' as const;
export const SET_LINEAR_GRAPH_LOADING = '[dashboard] Set linear graph loading' as const;
export const SET_LINEAR_GRAPH_DATA = '[dashboard] Set linear graph data' as const;
export const SHIFT_LINEAR_GRAPH = '[dashboard] Shift linear graph' as const;

export const REQUEST_SUMMARY_GRAPH_DATA = '[dashboard] Request summary graph data' as const;
export const SET_SUMMARY_GRAPH_MODE = '[dashboard] Set summary graph mode' as const;
export const SET_SUMMARY_GRAPH_LOADING = '[dashboard] Set summary graph loading' as const;
export const SET_SUMMARY_GRAPH_DATA = '[dashboard] Set summary graph data' as const;
export const SET_SUMMARY_GRAPH_START_DATE = '[dashboard] Set summary graph start date' as const;

export const CREATE_ORDER_REQUEST = '[dashboard] Create order request' as const;
export const CREATE_ORDER_SUCCESS = '[dashboard] Create order success' as const;
export const CREATE_ORDER_FAILED = '[dashboard] Create order failed' as const;

export const CREATE_BULK_ORDER_REQUEST = '[dashboard] Create bulk order request' as const;
export const CREATE_BULK_ORDER_SUCCESS = '[dashboard] Create bulk order success' as const;
export const CREATE_BULK_ORDER_FAILED = '[dashboard] Create bulk order failed' as const;

export const UPLOAD_BULK_ORDER_REQUEST = '[dashboard] Upload bulk order request' as const;
export const UPLOAD_BULK_ORDER_SUCCESS = '[dashboard] Upload bulk order success' as const;
export const UPLOAD_BULK_ORDER_FAILED = '[dashboard] Upload bulk order failed' as const;

export const BULK_EMAIL_VALIDATION_REQUEST = '[dashboard] Bulk email validation request' as const;
export const BULK_EMAIL_VALIDATION_SUCCESS = '[dashboard] Bulk email validation success' as const;
export const BULK_EMAIL_VALIDATION_FAILED = '[dashboard] Bulk email validation failed' as const;

export const CLEAR_ORDERS_STATE = '[dashboard] Clear orders state' as const;
